import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import SkeletonTicketList from '../../loaders/SkeletonTicketList'
import { TABLE_ROWS_PER_PAGE } from '../../utils/Constants';
import { GlobalIconNames } from '../../utils/GlobalIconNames';
import Str from './Str';
import Tablefilter from './Tablefilter';
import Papa from "papaparse";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import { handleTableScroll } from '../../utils/commonFunction';
import TableDateFilter from './TableDateFilter';
import TableDateRangeFilter from './TableDateRangeFilter';
import TableTypeFilter from './TableTypeFilter';

const defaultExportFunction = (fileType, fileName) => {
    let data = [];
    const header = [];
    if (fileType == "csv") {
        const csvString = Papa.unparse({ fields: header, data });
        const blob = new Blob([csvString], {
            type: "text/csv;charset=utf-8,",
        });

        const blobURL = window.URL.createObjectURL(blob);

        const anchor = document.createElement("a");
        anchor.download = fileName;
        anchor.href = blobURL;
        anchor.dataset.downloadurl = [
            "text/csv",
            anchor.download,
            anchor.href,
        ].join(":");
        anchor.click();

        setTimeout(() => {
            URL.revokeObjectURL(blobURL);
        }, 1000);
    } else if (fileType === "xlsx") {
        const compatibleData = data.map((row) => {
            const obj = {};
            header.map((col, index) => {
                obj[col] = row[col];
            });
            return obj;
        });

        let wb = XLSX.utils.book_new();
        let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
            header,
        });
        XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
        XLSX.writeFile(wb, `${fileName}.xlsx`);

        return false;
    }
    if (fileType === "pdf") {
        const compatibleData = data.map((row) => {
            return [];
        });
        const doc = new JsPDF();
        doc.autoTable({
            head: [header],
            body: compatibleData,
            styles: {
                minCellHeight: 10,
                minCellWidth: 5,
                halign: "left",
                fontSize: 8,
            },
        });
        doc.save(`${fileName}.pdf`);

        return false;
    }
}

/**
 * Reusable wrapper around react-data-table-component that provides
 * server-side pagination, sorting, searching, filtering, export actions,
 * reset functionality, and custom action buttons.
 *
 * @param {Object} props Component props.
 * @param {Array<Object>} [props.data=[]] Table row data.
 * @param {boolean} [props.isExport=true] Whether export buttons (CSV, XLSX, PDF) are displayed.
 * @param {Function} [props.setIsChildReset] Optional callback used to notify child filters that a reset has occurred.
 * @param {boolean} [props.loading=false] Whether the table is currently loading data.
 * @param {Object} [props.state={}] Table state object containing pagination and sorting information.
 * @param {number} [props.state.page] Current page number.
 * @param {number} [props.state.perPage] Number of rows per page.
 * @param {string} [props.state.sortKey] Current sort field.
 * @param {string} [props.state.sortOrder] Current sort direction.
 * @param {Function} [props.setState=() => {}] State setter used for pagination and sorting updates.
 * @param {Function} [props.setSearch=() => {}] Callback invoked when the search term changes.
 * @param {number} [props.totalRows=0] Total number of rows available for server-side pagination.
 * @param {Array<Object>} [props.columns=[]] DataTable column definitions.
 * @param {Function} [props.exportFunction=defaultExportFunction] Function used when exporting data.
 * @param {string} [props.exportFileName=""] Filename used for exported files.
 * @param {Array<Object>} [props.filters=[]] Filter configuration objects rendered above the table.
 * @param {Array<React.ReactNode>} [props.tableButton=[]] Action buttons displayed above the table.
 * @param {boolean} [props.isInsidePopUp=false] Applies popup-specific table styling.
 * @param {Array<React.ReactNode>} [props.bottomButton=[]] Elements rendered below the table.
 * @param {Object} [props.otherTableProps={}] Additional props passed directly to the underlying DataTable component.
 * @param {boolean} [props.isActionAlignRight=false] Whether action controls should be aligned to the right.
 * @param {string} [props.keyField="id"] Unique row identifier field.
 * @param {boolean} [props.resetModal=false] Triggers a table filter reset when set to true.
 * @param {Object} [props.btnStyleOverride={}] Inline styles applied to the reset button.
 * @param {Object} [props.containerStyle={}] Inline styles applied to the table container wrapper.
 * @param {Function} [props.setResetModal=() => {}] Callback used to clear the resetModal flag after reset.
 * @returns {JSX.Element} Rendered data table component.
 */
function DataTableComponent({
    data = [],
    isExport = true,
    setIsChildReset = undefined,
    loading = false,
    state = {},
    setState = () => { },
    setSearch = () => { },
    totalRows = 0,
    columns = [],
    exportFunction = defaultExportFunction,
    exportFileName = "",
    filters = [],
    tableButton = [],
    isInsidePopUp = false,
    bottomButton = [],
    otherTableProps = {},
    isActionAlignRight = false,
    keyField = "id",
    resetModal = false,
    btnStyleOverride = {},
    containerStyle = {},
    filterBtnSpacing = '0px',
    setResetModal = () => { }
}) {
    let page = state?.page;
    let perPage = state?.perPage;
    let sortKey = state?.sortKey;

    const [debouncedTerm, setDebouncedTerm] = useState("")

    const handlePageChange = (pageNo) => {
        setState((prevState) => ({ ...prevState, page: pageNo }));
    };

    const handlePerRowsChange = (newPerPage) => {
        setState((prevState) => ({ ...prevState, perPage: newPerPage }));
    };

    const handleSort = (column, sortDirection) => {
        setState((prevState) => {
            return ({ ...prevState, sortKey: column.sortField, sortOrder: sortDirection === "asc" ? "asc" : "desc" })
        });
    };

    const resetFilter = () => {
        
        if(setIsChildReset != undefined){

            setIsChildReset(true)
        }
        filters.map(item => {
            if(!item.notReset){
                item.setState({ arr: [], checkObj: item.isSearchFilter ? [] : {} })
            }
            if(item.dateFilter==true){
                item.setState("")
            }
            if(item.dateRangeFilter==true){
                item.setState({startDate:null, endDate : null})
            }
        })
        setSearch("");
        setDebouncedTerm("");
    }

    useEffect(() => {
        const timer = setTimeout(() => (() => {
            setSearch(debouncedTerm);
        })(), 1000);
        return () => {
            clearTimeout(timer);
        }
    }, [debouncedTerm])

    useEffect(() => {
        handleTableScroll()
      }, [loading])

    useEffect(() => {
        if (resetModal == true) {
            resetFilter();
            setResetModal(false);
        }
    }, [resetModal]);

    return (
        <div className="my-tickets-info-list Tickets-main-wrap">
            <div
                className={isInsidePopUp ? "l-o-c-t custom-table-div filter-search-icon card-table-custom course-table-filter-sec new-table-box" : `custom-table-div filter-search-icon card card-table-custom program-table ${isActionAlignRight ? "action-align-right" : ""}`}
                style={containerStyle}
            >
                <div className="search-filter-div">
                    <div className="search-filter-div-left">
                        <div className="system-administration-table table-responsive">
                            <div className="table-responsive-div">
                                <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                                    <div id="assessment-table-main_filter" className="dataTables_filter">
                                        <label>
                                            <input
                                                type="search"
                                                className=""
                                                placeholder="Search"
                                                aria-controls="assessment-table-main"
                                                onChange={e => setDebouncedTerm(e.target.value)}
                                                value={debouncedTerm}
                                            />
                                        </label>
                                        <div className="filter-eff filter-data-btn">
                                            <button className="filter-buttons">
                                                {GlobalIconNames("filter")}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="filter-button-group">
                                <div className="filter-scroll">
                                    <div
                                        className={`filter-scroll-inner filter-custom-new`}
                                        style={{ gap: filterBtnSpacing }}>
                                        {filters.map((item, index) => {
                                            const btnStyleOverrideProps = btnStyleOverride && { btnStyleOverride };
                                            return (<div key={index}>
                                                {item.dateFilter === true ?
                                                    <TableDateFilter {...item} />
                                                    : item.dateRangeFilter === true ?
                                                        <TableDateRangeFilter {...item} />
                                                        : item.isProgrammeType === true ?
                                                            <TableTypeFilter {...item} />
                                                            : <Tablefilter {...item} {...btnStyleOverrideProps} />
                                                }
                                            </div>)
                                        })}
                                    </div>
                                </div>
                                <div className="reset-btn-group" style={{ marginLeft: filterBtnSpacing }}>
                                    <div className="button-reset dropdown-comman">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            style={btnStyleOverride}
                                            onClick={resetFilter}
                                            title="Reset"
                                        >
                                            {GlobalIconNames("reset").html}
                                        </button>
                                    </div>
                                    {isExport && <div className="files-export-group">
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportFunction("xlsx", exportFileName || 'fileName');
                                            }}
                                            title="Export spreadsheet"
                                        >
                                            {GlobalIconNames("excel")}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportFunction("csv", exportFileName || 'fileName');
                                            }}
                                            title="Export CSV"
                                        >
                                            {GlobalIconNames("csv")}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportFunction("pdf", exportFileName || 'fileName');
                                            }}
                                            title="Export PDF"
                                        >
                                            {GlobalIconNames("pdf")}
                                        </button>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="search-filter-div-right">
                        <div className=" filter-search-bar-blk">
                            <div className="add-ticket-blk button-reset dropdown-comman">
                                {tableButton.map((item, index) => (
                                    <div key={index}>
                                        {item}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                {/* {loading ? <SkeletonTicketList /> :  */}
                <DataTable
                    paginationDefaultPage={page}
                    data={data}
                    defaultSortField={sortKey}
                    // sorting doesn't work properly if loading is not added like this
                    progressPending={loading}
                    progressComponent={<SkeletonTicketList />}
                    defaultSortAsc={state.sortOrder === "ASC" || state.sortOrder === "asc"}
                    columns={columns}
                    pagination={true}
                    noDataComponent={Str.noRecord}
                    onSort={handleSort}
                    sortServer
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    highlightOnHover={false}
                    paginationPerPage={perPage}
                    keyField={keyField}
                    paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
                    {...otherTableProps}
                />
                {bottomButton.map((item, index) => (
                    <div key={index}>
                        {item}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default React.memo(DataTableComponent)